<template>
  <div>
    <div>
      <router-view></router-view>
    </div>
    <homeFooter class="homeFooter" />
  </div>
</template>

<script>
  import homeFooter from "@/components/home/homeFooter.vue"
  export default {
    components: {
      homeFooter
    },
    mounted() {
      var dif = new Date().getTime() - window.localStorage.getItem('authTime')
      dif = dif / (1000 * 60 * 60)
      if (window.localStorage.getItem('token') && dif > 24) {
        window.localStorage.clear()
      }
    }
  }
</script>

<style scoped>
  .homeHeader {
    position: fixed;
    top: 0;
    z-index: 100;
  }

  .homeFooter {
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 100
  }
</style>